import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { StandardChecklistDto } from 'app/api/models/employee/standardChecklistDto';
import { StandardChecklistItemDto } from 'app/api/models/employee/standardChecklistItemDto';
import { EmployeeTodoService } from 'app/api/services/employeeTodos.serive';

@UntilDestroy()
@Component({
    selector: 'app-checklist-modal',
    templateUrl: './checklist-modal.component.html',
    styleUrls: ['./checklist-modal.component.scss'],
    standalone: false
})
export class ChecklistModalComponent implements OnInit {
  @Input() tenantId!: string;
  @Input() loading: boolean = false;
  @Input() isOpen: boolean = false;
  @Input() editedTodo: Partial<StandardChecklistDto> | undefined;
  @Output() checklistCreated = new EventEmitter<void>();

  editForm!: FormGroup;
  submitErrors: string[] | null = null;
  items: StandardChecklistItemDto[] = [];

  constructor(
    private formBuilder: FormBuilder,
    private service: EmployeeTodoService
  ) {}

  ngOnInit() {
    this.initForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isOpen'] && changes['isOpen'].currentValue === true) {
      this.resetForm();
    }
  }

  private resetForm(): void {
    if (this.editForm) {
      this.editForm.reset();
      this.checkListItemFormArray.clear();
    }
  }

  private initForm() {
    this.editForm = this.formBuilder.group({
      tenantId: this.tenantId,
      title: ['', Validators.required],
      items: this.formBuilder.array([]),
    });
  }

  get checkListItemFormArray(): FormArray {
    return this.editForm.get('items') as FormArray;
  }

  removeChecklistItem(index: number) {
    this.checkListItemFormArray.removeAt(index);
  }

  addChecklistItem() {
    this.checkListItemFormArray.push(
      this.formBuilder.group({
        id: [null],
        title: ['', Validators.required],
        standardChecklistId: [null],
        order: [0],
      })
    );
  }

  onSubmit() {
    if (this.editForm.invalid) {
      this.editForm.markAllAsTouched();
      return;
    }

    const formValue = this.editForm.value;
    const checklist: Partial<StandardChecklistDto> = {
      tenantId: this.tenantId,
      title: formValue.title,
      items: this.checkListItemFormArray.value,
    };

    this.service
      .createStandardChecklist(checklist)
      .pipe(untilDestroyed(this))
      .subscribe(() => {
        this.checklistCreated.emit();
        this.editForm.reset();
      });
  }
}
